import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { CenterDataForm, CenterFilters } from '../../models/Center';

const useCenterService = () => {
  const { doGet, doPost, doPut, doDelete } = useFetch();

  const [fetchingGetCenters, setFetchingGetCenters] = useState(false);
  const [fetchingShowCenter, setFetchingShowCenter] = useState(false);
  const [fetchingCreateCenter, setFetchingCreateCenter] = useState(false);
  const [fetchingStoreCenter, setFetchingStoreCenter] = useState(false);
  const [fetchingEditCenter, setFetchingEditCenter] = useState(false);
  const [fetchingUpdateCenter, setFetchingUpdateCenter] = useState(false);
  const [fetchingDeleteCenter, setFetchingDeleteCenter] = useState(false);
  const [fetchingActiveCenter, setFetchingActiveCenter] = useState(false);

  const getCenters = (filters: CenterFilters, events: ServiceEvents = {}) => {
    const queryString = Object.entries(filters).map(([k, v]) => `${k}=${v}`).join('&');
    doGet({ ...events, url: `${EndPoints.CENTERS.GET_CENTERS}?${queryString}`, setFetching: setFetchingGetCenters });
  };

  const createCenter = (events: ServiceEvents = {}) =>
    doGet({ ...events, url: EndPoints.CENTERS.CREATE_CENTER, setFetching: setFetchingCreateCenter });

//   const showCenter = (id: number, events: ServiceEvents = {}) =>
//     doGet({ ...events, url: EndPoints.CENTERS.SHOW_CENTER.replace(':id', id.toString()), setFetching: setFetchingShowCenter });

  const storeCenter = (data: CenterDataForm, events: ServiceEvents = {}) =>
    doPost({ ...events, url: EndPoints.CENTERS.STORE_CENTER, body: data, setFetching: setFetchingStoreCenter });

  const editCenter = (id: number, events: ServiceEvents = {}) =>
    doGet({ ...events, url: EndPoints.CENTERS.EDIT_CENTER.replace(':id', id.toString()), setFetching: setFetchingEditCenter });

  const updateCenter = (id: number, data: CenterDataForm, events: ServiceEvents = {}) =>
    doPut({ ...events, url: EndPoints.CENTERS.UPDATE_CENTER.replace(':id', id.toString()), body: data, setFetching: setFetchingUpdateCenter });

  const deleteCenter = (id: number, events: ServiceEvents = {}) =>
    doDelete({ ...events, url: EndPoints.CENTERS.DELETE_CENTER.replace(':id', id.toString()), setFetching: setFetchingDeleteCenter });

  const activeCenter = (id: number, active: boolean, events: ServiceEvents = {}) =>
    doPost({ ...events, url: EndPoints.CENTERS.ACTIVE_CENTER.replace(':id', id.toString()), body: { active }, setFetching: setFetchingActiveCenter });

  return {
    fetchingGetCenters,
    fetchingShowCenter,
    fetchingCreateCenter,
    fetchingStoreCenter,
    fetchingEditCenter,
    fetchingUpdateCenter,
    fetchingDeleteCenter,
    fetchingActiveCenter,
    getCenters,
    // showCenter,
    createCenter,
    storeCenter,
    editCenter,
    updateCenter,
    deleteCenter,
    activeCenter,
  };
};

export default useCenterService;
